export default __webpack_public_path__ + "static/media/cookies-notAccepted.ba92efdf.svg";